import { Chip, ChipProps } from '@mui/material'
import { FC } from 'react'

export type C1ChipProps = Omit<ChipProps, 'label' | 'size'> & {
    label: NonNullable<React.ReactNode>
    size?: 'small' | 'medium' | 'extraSmall'
}

export const extraSmallChipSx = { fontSize: '10px', height: '16px', ml: '6px' }

export const C1Chip: FC<C1ChipProps> = (props) => {
    const { size, ...rest } = props
    const chipSize = size === 'extraSmall' ? 'small' : size
    const chipSx = size === 'extraSmall' ? extraSmallChipSx : rest.sx

    return <Chip {...rest} size={chipSize} sx={chipSx} />
}
